import React from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core'; // Adjust import according to your setup
import { Button } from "primereact/button";
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import { printPlugin } from '@react-pdf-viewer/print';
import { getFilePlugin } from '@react-pdf-viewer/get-file';

const FileViewer = ({ fileUrl, isEdit = false, cancelFileOnEditBtn, onRemove, file, type }: any) => {
    const zoomPluginInstance = zoomPlugin();
    const printPluginInstance = printPlugin();
    const { PrintButton } = printPluginInstance;
    const { ZoomInButton, ZoomOutButton, ZoomPopover } = zoomPluginInstance;
    const getFilePluginInstance = getFilePlugin();
    const { DownloadButton } = getFilePluginInstance;

  return (
    <div className="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center">
      <div
        className="rpv-core__viewer tw-w-full tw-h-full"
        style={{
          border: "1px solid rgba(0, 0, 0, 0.3)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            alignItems: "center",
            backgroundColor: "#eeeeee",
            borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
            display: "flex",
            justifyContent: "center",
            padding: "4px",
          }}
        >
          <ZoomOutButton />
          <ZoomPopover />
          <ZoomInButton />
          <PrintButton />
          <DownloadButton />
          {onRemove && <Button
          type="button"
          icon={`pi ${type === "addInvoice" ? "pi-times" : "pi-pencil"}`}
          className="tw-mr-0 tw-right clear-file-btn p-button-outlined p-button-rounded p-button-danger"
          onClick={() => onRemove(file)}
        />}
        </div>

        {fileUrl && (
          <div style={{ flex: 1, overflow: "hidden" }}>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
              <Viewer
                fileUrl={fileUrl}
                plugins={[
                  zoomPluginInstance,
                  printPluginInstance,
                  getFilePluginInstance,
                ]}
              />
            </Worker>
            {isEdit && (
              <Button
                type="button"
                icon="pi pi-times"
                className="ml-auto clear-file-btn p-button-outlined p-button-rounded p-button-danger"
                onClick={cancelFileOnEditBtn}
              />
            )}
          </div>
        )}
      
      </div>
    </div>
  );
};

export default React.memo(FileViewer);
